export const STEPS = {
    GENERAL_DETAILS: 1,
    PERSONAL_DETAILS: 2,
    THANK_YOU: 3,
    ERROR: 4
}



// WEBPACK FOOTER //
// ./Src/Components/CallForm/CallForm/constants.js